"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bs = require("react-icons/bs");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Accordion = function Accordion(props) {
  var title = props.title,
      markContent = props.markContent,
      rightContent = props.rightContent,
      leftContent = props.leftContent,
      className = props.className,
      children = props.children,
      width = props.width,
      restrictedOpening = props.restrictedOpening,
      availableManualOpening = props.availableManualOpening,
      showManualContent = props.showManualContent,
      setShowManualContent = props.setShowManualContent;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showContent = _useState2[0],
      setShowContent = _useState2[1];

  var handleClick = function handleClick() {
    if (!availableManualOpening) {
      setShowContent(!showContent);
    } else {
      setShowManualContent(!showManualContent);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-acc ".concat(className),
    style: {
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-acc-header",
    onClick: restrictedOpening ? function () {} : function () {
      return handleClick();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "leftContent"
  }, title && /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, title), leftContent ? leftContent : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "rightContent"
  }, rightContent ? rightContent : null, showContent || showManualContent ? /*#__PURE__*/_react.default.createElement(_bs.BsChevronUp, {
    className: "icons",
    onClick: handleClick
  }) : /*#__PURE__*/_react.default.createElement(_bs.BsChevronDown, {
    className: "icons",
    onClick: handleClick
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-acc-body ".concat(showContent || showManualContent ? 'active' : '', " ").concat(markContent)
  }, children));
};

Accordion.propTypes = {
  title: _propTypes.default.string,
  markContent: _propTypes.default.oneOf(['close', 'primary', 'none']),
  rightContent: _propTypes.default.element,
  leftContent: _propTypes.default.element,
  className: _propTypes.default.string,
  children: _propTypes.default.element,
  width: _propTypes.default.string,
  restrictedOpening: _propTypes.default.bool,
  availableManualOpening: _propTypes.default.bool,
  showManualContent: _propTypes.default.bool,
  setShowManualContent: _propTypes.default.func
};
Accordion.defaultProps = {
  title: '',
  markContent: 'none',
  rightContent: null,
  leftContent: null,
  className: '',
  children: null,
  width: null,
  restrictedOpening: false,
  availableManualOpening: false,
  showManualContent: false,
  setShowManualContent: function setShowManualContent() {}
};
var _default = Accordion;
exports.default = _default;